module.exports = __webpack_public_path__ + "img/asterisk.cafef341.svg";